import { useState } from "react";
import { useSEO } from "@/hooks/useSEO";
import { Reveal } from "@/components/shared/Reveal";
import { POLICY_LINKS } from "@/data/siteData";
import { POLICIES } from "@/data/policiesData";

export default function Policies() {
  useSEO(
    "Policies | The Market Place Jaipur",
    "Booking & Cancellation Policy, Stall & Vendor Participation Policy, Terms & Conditions and Privacy Policy for The Market Place, Jaipur."
  );
  const [activeId, setActiveId] = useState(POLICY_LINKS[0].id);
  const active = POLICIES.find((p) => p.id === activeId);

  return (
    <div data-testid="policies-page" className="pt-16 pb-16 px-6 sm:px-8 max-w-6xl mx-auto">
      <Reveal>
        <span className="font-mono text-xs uppercase tracking-[0.25em] text-[#D81B60]">Policies</span>
        <h1 className="font-extrabold tracking-tight text-4xl sm:text-5xl mt-4 mb-2">Booking, Terms &amp; Privacy</h1>
        <p className="text-gray-500 max-w-2xl">Last Updated: August 2026. Please read these carefully before applying for or booking a stall at The Market Place.</p>
      </Reveal>

      <div className="grid lg:grid-cols-[240px_1fr] gap-10 mt-12">
        <nav data-testid="policy-nav" className="flex lg:flex-col gap-2 overflow-x-auto lg:overflow-visible -mx-1 lg:mx-0 pb-2 lg:pb-0 lg:sticky lg:top-28 lg:self-start">
          {POLICY_LINKS.map((link) => (
            <button
              key={link.id}
              onClick={() => setActiveId(link.id)}
              data-testid={`policy-nav-${link.id}`}
              className={`text-left whitespace-nowrap rounded-xl px-4 py-3 text-sm font-semibold transition-colors duration-300 flex-shrink-0 ${
                activeId === link.id ? "bg-[#D81B60] text-white" : "bg-[#FDFBF7] text-gray-600 hover:bg-[#FDF2F5]"
              }`}
            >
              {link.label}
            </button>
          ))}
        </nav>

        {active && (
          <div data-testid={`policy-content-${active.id}`} className="min-w-0">
            <Reveal key={active.id}>
              <h2 className="font-extrabold text-2xl sm:text-3xl mb-4">{active.title}</h2>
              <p className="text-gray-500 leading-relaxed mb-8">{active.intro}</p>
              <div className="space-y-8">
                {active.sections.map((s) => (
                  <div key={s.heading}>
                    <h3 className="font-bold text-lg mb-2 text-[#1A1A1A]">{s.heading}</h3>
                    {s.paragraphs?.map((p, i) => (
                      <p key={i} className="text-gray-600 leading-relaxed mb-2">{p}</p>
                    ))}
                    {s.list && (
                      <ul className="list-disc list-outside ml-5 space-y-1.5 text-gray-600 mb-2">
                        {s.list.map((item, i) => (
                          <li key={i}>{item}</li>
                        ))}
                      </ul>
                    )}
                    {s.outro && <p className="text-gray-600 leading-relaxed mt-2">{s.outro}</p>}
                  </div>
                ))}
              </div>
            </Reveal>
          </div>
        )}
      </div>
    </div>
  );
}
